"use strict";

exports.__esModule = true;
exports.getRemoveItemClickHandler = exports.getColorChangeHandler = exports.getAvailableItems = exports.getAddItemClickHandler = void 0;
var getAvailableItems = exports.getAvailableItems = function getAvailableItems(_ref) {
  var items = _ref.items,
    selectedItems = _ref.selectedItems,
    getKey = _ref.getKey;
  return selectedItems ? items.filter(function (item) {
    return !selectedItems.find(function (selected) {
      return getKey(selected) === getKey(item);
    });
  }) : items;
};
var getColorChangeHandler = exports.getColorChangeHandler = function getColorChangeHandler(_ref2) {
  var selectedItems = _ref2.selectedItems,
    onChange = _ref2.onChange,
    index = _ref2.index;
  return function (color) {
    if (selectedItems) {
      var updated = selectedItems.slice();
      updated[index] = Object.assign({}, updated[index], {
        color: color
      });
      onChange(updated);
    }
  };
};
var getAddItemClickHandler = exports.getAddItemClickHandler = function getAddItemClickHandler(_ref3) {
  var availableItems = _ref3.availableItems,
    selectedItems = _ref3.selectedItems,
    defaultColor = _ref3.defaultColor,
    onChange = _ref3.onChange;
  return function () {
    var updatedValues = [].concat(selectedItems || [], [Object.assign({}, availableItems[0], {
      color: defaultColor
    })]);
    onChange(updatedValues);
  };
};
var getRemoveItemClickHandler = exports.getRemoveItemClickHandler = function getRemoveItemClickHandler(_ref4) {
  var selectedItems = _ref4.selectedItems,
    onChange = _ref4.onChange,
    index = _ref4.index;
  return function () {
    if (selectedItems) {
      var updated = selectedItems.slice();
      updated.splice(index, 1);
      onChange(updated);
    }
  };
};